import React, {useEffect, useState} from 'react';
import ConfirmButton from '../common/ConfirmButton';
import './shoppingList.css';

const ShoppingListShareDialog = ({
    open,
    list,
    companyUsers,
    currentUserId,
    onClose,
    onSave,
}) => {
    const [selectedUserIds, setSelectedUserIds] = useState([]);

    useEffect(() => {
        if (!open || !list) {
            return;
        }
        setSelectedUserIds(list.sharedUserIds || []);
    }, [open, list]);

    if (!open || !list) {
        return null;
    }

    const excludeUserId = currentUserId ?? list.ownerUserId;
    const selectableUsers = (companyUsers || []).filter(
        (user) => user.id != null && user.id !== excludeUserId,
    );

    const toggleUser = (userId) => {
        setSelectedUserIds((prev) => (
            prev.includes(userId)
                ? prev.filter((id) => id !== userId)
                : [...prev, userId]
        ));
    };

    const handleBackdropClick = (event) => {
        if (event.target === event.currentTarget) {
            onClose();
        }
    };

    return (
        <div
            className="shopping-list-share-dialog-backdrop"
            onClick={handleBackdropClick}
            role="presentation"
        >
            <div
                className="shopping-list-share-dialog"
                role="dialog"
                aria-labelledby="shopping-list-share-dialog-title"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="shopping-list-share-dialog__header">
                    <h2 id="shopping-list-share-dialog-title">Compartilhar lista</h2>
                    <button
                        type="button"
                        className="shopping-list-share-dialog__close"
                        onClick={onClose}
                        aria-label="Fechar"
                    >
                        ×
                    </button>
                </div>
                <p className="shopping-list-share-dialog__subtitle">{list.name}</p>
                <div className="shopping-list-share-dialog__users">
                    {selectableUsers.map((user) => (
                        <label key={user.id} className="shopping-list-share-item">
                            <input
                                type="checkbox"
                                checked={selectedUserIds.includes(user.id)}
                                onChange={() => toggleUser(user.id)}
                            />
                            <span>{user.name}</span>
                        </label>
                    ))}
                    {selectableUsers.length === 0 && (
                        <span className="shopping-list-muted">Nenhum usuário disponível.</span>
                    )}
                </div>
                <div className="shopping-list-share-dialog__actions">
                    <ConfirmButton onClick={() => onSave(selectedUserIds)}/>
                </div>
            </div>
        </div>
    );
};

export default ShoppingListShareDialog;
